import { render } from "./info-issue-count.vue?vue&type=template&id=d6541d30&scoped=true"
import script from "./info-issue-count.vue?vue&type=script&lang=js"
export * from "./info-issue-count.vue?vue&type=script&lang=js"

import "./info-issue-count.vue?vue&type=style&index=0&id=d6541d30&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6541d30"]])

export default __exports__